import React from 'react';
import { FadeIn } from './FadeIn';
export function Craft() {
  const steps = [{
    num: '01',
    title: 'עיצוב'
  }, {
    num: '02',
    title: 'ליטוש'
  }, {
    num: '03',
    title: 'שיבוץ'
  }];
  return <section id="craft" className="py-32 md:py-48 bg-white/30" data-id="element-59">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 lg:gap-32 items-center" data-id="element-61">
          <FadeIn className="order-2 lg:order-1" data-id="element-62">
            <div className="aspect-[4/5] bg-gradient-to-tr from-ivory via-[#f0ece1] to-white relative overflow-hidden" data-id="element-63">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(196,165,114,0.1)_0%,transparent_70%)]" data-id="element-64" />
            </div>
          </FadeIn>

          <div className="order-1 lg:order-2 flex flex-col justify-center" data-id="element-65">
            <FadeIn data-id="element-66">
              <h2 className="serif text-4xl md:text-5xl text-charcoal mb-12" data-id="element-67">
                אמנות המסורת
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-68">
              <p className="text-charcoal/70 font-light leading-relaxed text-lg md:text-xl max-w-lg mb-16" data-id="element-69">
                כל תכשיט שיוצא מהסדנה שלנו הוא תוצר של שעות ארוכות של עבודה
                ידנית קפדנית. אנו משלבים טכניקות עתיקות יומין עם חדשנות מודרנית,
                כדי ליצור פריטים שהם לא רק יפים, אלא גם על-זמניים.
              </p>
            </FadeIn>

            <div className="flex flex-col gap-8" data-id="element-70">
              {steps.map((step, index) => <FadeIn key={step.num} delay={0.4 + index * 0.1} data-id="element-71">
                  <div className="flex items-center gap-6 group" data-id="element-72">
                    <span className="serif-latin text-gold text-xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" data-id="element-73">
                      {step.num}
                    </span>
                    <span className="label-tiny text-charcoal" data-id="element-74">
                      {step.title}
                    </span>
                    <div className="flex-grow h-px bg-charcoal/10 group-hover:bg-gold/30 transition-colors duration-500" data-id="element-75" />
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}